import { ActionConfig, ActionContext, IAction } from '../Action'

export class SubmitExamAction implements IAction {
    static Id = 'SubmitExam' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.addAction(
            {
                id: 'submit-and-next',
                title: this.config?.title ?? 'Submit',
                type: 'button',
                onClick:
                    this.config?.onClick ??
                    (async () => {
                        const canSubmit = await this.actionContext.task.validateData()
                        if (!canSubmit) {
                            return
                        }
                        const errors =
                            this.actionContext.studio.inputManager.getViolationCount('error')
                        if (errors > 0) {
                            return
                        }
                        try {
                            await this.actionContext.task.flushPendingAutoSave()
                            this.actionContext.studio.nextTask()
                        } catch (error) {
                            console.error('submitExam', error)
                        }
                    }),
                color: 'primary',
                disabled: this.config?.disabled ?? false,
                tooltip: this.config?.tooltip,
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.removeAction('submit-and-next')
    }
}
